module.exports = __webpack_public_path__ + "static/media/logo.266fbfda.svg";